module.exports = __webpack_public_path__ + "img/_chico_padel_rascacielos_bono.462df33b.png";